import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    const schema = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    };
    script.textContent = JSON.stringify(schema);
    script.id = `schema-${type}`;

    const existing = document.getElementById(`schema-${type}`);
    if (existing) existing.remove();

    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(`schema-${type}`);
      if (el) el.remove();
    };
  }, [type, JSON.stringify(data)]);

  return null;
}